import React from 'react';
import PropTypes from 'prop-types';
import { SelectField, Icon } from '@unite-us/ui';
import { validations } from '@unite-us/app-components';
import ToolTip from 'common/ToolTip';

const ButtonComponent = () => (
  <Icon
    icon="IconInfoCircle"
    className="fill-current text-text-blue"
    ariaLabel="ProgramNameInformation"
  />
);

const ToolTipContent = () => (
  <p className="bg-white mb-2 w-60 sm:w-40 p-4 border border-text-blue border-solid rounded">
    Programs for authorized services cannot be changed.
  </p>
);

const AuthorizedProgramDisplay = ({ programText, programClass }) => (
  <div className="display-field text-sm mb-6">
    <h5 className="text-secondary display-field__label mb-4">PROGRAM</h5>
    <div className="flex">
      <span className={programClass}>
        {programText}
      </span>
      <ToolTip
        buttonComponentContent={ButtonComponent}
        enableHover
        panelComponentContent={ToolTipContent}
        panelClassName="z-modal"
        placement="bottom"
        offsetOptions={{
          offset: [0, 14],
        }}
        flipOptions={{
          fallbackPlacements: [],
        }}
      />
    </div>
  </div>
);

const StandardProgramSelect = ({
  registerField,
  program_id,
  programOptions,
  onChange,
}) => (
  <SelectField
    className="accept-referral-program-select"
    ref={registerField}
    field={program_id}
    label="Program"
    id="programSelect"
    options={programOptions}
    onChange={onChange}
    inline={false}
    validations={validations.isRequired}
    required
  />
);

const ProgramField = ({
  authorizationReferral,
  registerField,
  program_id,
  programOptions,
  onChange,
  programId,
}) => {
  const programFound = programOptions.find((p) => p.value === programId);
  const isProgramInactive = !programFound && authorizationReferral;
  const programText = isProgramInactive ? 'Program is temporarily inactive' : programFound?.label;
  const programClass = `mr-1 ${isProgramInactive ? 'text-red' : ''}`;

  if (authorizationReferral) {
    return <AuthorizedProgramDisplay programText={programText} programClass={programClass} />;
  }

  return (
    <StandardProgramSelect
      registerField={registerField}
      program_id={program_id}
      programOptions={programOptions}
      onChange={onChange}
    />
  );
};

AuthorizedProgramDisplay.propTypes = {
  programText: PropTypes.string,
  programClass: PropTypes.string,
};

StandardProgramSelect.propTypes = {
  registerField: PropTypes.func,
  program_id: PropTypes.object,
  programOptions: PropTypes.array,
  onChange: PropTypes.func,
};

ProgramField.propTypes = {
  authorizationReferral: PropTypes.object,
  registerField: PropTypes.func,
  program_id: PropTypes.object,
  programOptions: PropTypes.array,
  onChange: PropTypes.func,
  programId: PropTypes.string,
};

export default ProgramField;
export { ProgramField };
